module.exports = __webpack_public_path__ + "img/Diagram V1.c7976dbc.jpg";